import React, { FC } from 'react';
import moment, { Moment } from 'moment';
import buttons from 'style/buttons.module.scss';
import Title from 'components/common/Title';
import moduleStyles from 'pages/timetable/styles.module.scss';
import { UserSubscriptionStatus } from 'types';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import { Trackable } from '../../utils/hooks/useTrackable';
import { isSubscriptionCancelable } from '../../utils/helpers/payments';
import { AvailablePlan } from '../../reducers/payments';
import { TimeUnit } from '../../utils/constants/time';
import { selectAvailablePlans } from '../../selectors/payments';

interface Props {
  onBack: () => void;
  subscriptionStatus?: UserSubscriptionStatus;
  selectedPlan?: AvailablePlan;
  currentPlanId: string;
  currentSubscriptionEnd: number;
  onCancel: Trackable<() => Promise<void>>;
}

const CancelSubscription: FC<Props> = ({
  onBack,
  subscriptionStatus,
  currentPlanId,
  currentSubscriptionEnd,
  onCancel,
}) => {
  const availablePlans = useSelector(selectAvailablePlans);
  const selectedPlan = availablePlans.find((plan) => plan.id === currentPlanId);
  const subscriptionType =
    selectedPlan?.interval === 'year' ? 'Yearly plan' : 'Monthly plan';
  const expiresOnMoment = moment.utc(currentSubscriptionEnd * TimeUnit.Second);
  const startMoment = moment
    .utc(currentSubscriptionEnd * TimeUnit.Second)
    .subtract(1, selectedPlan?.interval);

  const formatYear = (data: Moment) => data.format('DD-MM-YYYY');

  return (
    <>
      <div className={`${styles.subscribing} ${styles.cancelSubscribing}`}>
        <div>
          <div className={`${styles.subscriptionDetails} ${styles.mainBlock}`}>
            <Title>Confirm Cancellation Details</Title>
            <div className={styles.table}>
              <div>
                <div>Details</div>
                <div />
              </div>
              <div>
                <div>Subscription type</div>
                <div>{subscriptionType}</div>
              </div>
              <div>
                <div>Billing period</div>
                <div>
                  {`${formatYear(startMoment)} to ${formatYear(
                    expiresOnMoment
                  )}`}
                </div>
              </div>
              <div>
                <div>Expires/Renews on</div>
                <div>{formatYear(expiresOnMoment)}</div>
              </div>
            </div>
          </div>
          <div className={`${styles.paymentForm} ${styles.mainBlock}`}>
            <div className={styles.unsubscribeList}>
              <span>If you cancel, you will no longer have</span>
              <ul>
                <li>
                  Ability to discover productive, fun and educational content
                </li>
                <li>
                  Ability to direct and manage what your kids are doing online
                  from afar
                </li>
                <li>
                  Unlimited Access to Aneta Map themes and Anetapack library
                </li>
                <li>Peace of mind for a few 25 cents a day!</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${moduleStyles.buttons} ${styles.bottomActions} ${styles.subscribeBottom}`}
      >
        <button
          onClick={onBack}
          className={buttons.buttonOutline}
          type="button"
        >
          Back
        </button>
        {isSubscriptionCancelable(subscriptionStatus) ? (
          <button
            type="submit"
            className={buttons.buttomPrimary}
            onClick={onCancel}
            disabled={onCancel.inProgress}
          >
            {onCancel.inProgress ? 'Canceling...' : 'Cancel'}
          </button>
        ) : null}
      </div>
    </>
  );
};

export default CancelSubscription;
